import { Alert, Button, Col, Form, Input, InputNumber, Modal, Row, Table, Tooltip } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { apiCall } from '../../API/RestApi';
import { modalError } from '../../Component/Modal/ModalLayout';
import { useSelector } from 'react-redux';
import Search from 'antd/es/input/Search';
import moment from 'moment';

function LeaveType() {
    const token = useSelector((state) => state.user.token);
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [isModal, setIsModal] = useState(false);
    const [dataModal, setdataModal] = useState(null);
    const [form] = Form.useForm();
    const [page, setPage] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
        sorter: {
            order: 'desc',
            columnKey: 'leave_type_id',
        }
    });
    const [isAlert, setIsAlert] = useState(false);
    const [textAlert, setTextAlert] = useState(false);

    const titlePage = 'Time Off Type Data';
    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
            key: "no",
            render: (id, record, index) => { ++index; return (page.pagination.current - 1) * page.pagination.pageSize + index },
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: "name",
            sorter: true,
        },
        {
            title: 'Total Leave Days',
            dataIndex: 'total_leave_days',
            key: "total_leave_days",
            sorter: true,
            render: (text, record) => {
                return record.total_leave_days + " day";
            }
        },
        {
            title: 'Created Date',
            dataIndex: 'created_at',
            key: "created_at",
            sorter: true,
            render: (text, record) => {
                return record.created_at ? moment(record.created_at).format('DD-MM-YYYY HH:mm:ss') : "-";
            }
        },
        {
            title: 'Updated Date',
            dataIndex: 'updated_at',
            key: "updated_at",
            sorter: true,
            render: (text, record) => {
                return record.updated_at ? moment(record.updated_at).format('YYYY-MM-DD HH:mm:ss') : "-";
            }
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => (
                <>
                    <Tooltip title="Edit">
                        <Button type="primary" style={{ marginRight: 10 }} onClick={() => openModal('edit', record)}>
                            <EditOutlined />
                        </Button>
                    </Tooltip>
                    <Tooltip title="Delete">
                        <Button type="primary" danger onClick={() => modalDeleteData(record)}>
                            <DeleteOutlined />
                        </Button>
                    </Tooltip>
                </>
            )
        },
    ];

    useEffect(() => {
        const order = page.sorter?.order === "ascend" ? 'asc' : 'desc';
        const columnKey = page.sorter?.columnKey || 'leave_type_id';
        getApi("GET", `/leavetype?search=${search}&page=${page.pagination.current}&limit=${page.pagination.pageSize}&sortBy=${columnKey}&order=${order}`, 'leavetype');
    }, [JSON.stringify(page), isAlert]);

    const getApi = (method, url, type) => {
        setLoading(true);
        const dataReq = {
            method: method,
            url: url,
            data: {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                setData(res.data.data);
                setPage(prev => ({
                    ...prev,
                    pagination: {
                        ...prev.pagination,
                        total: res.data.total_data
                    }
                }));
            }
            setLoading(false);
        }).catch(e => {
            console.log(e.message);
            setLoading(false);
        });
    };

    const postApi = async (method, url, values) => {
        setLoading(true);
        setIsAlert(false);
        const dataReq = {
            method: method,
            url: url,
            data: {
                data: values,
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        await apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                setdataModal(null);
                setTextAlert(res.message);
                setIsAlert(true);
                closeModal();
            } else {
                modalError(res.message);
            }
            setLoading(false);
        }).catch((e) => {
            console.log(e.message);
            setLoading(false);
        });
    };

    const modalDeleteData = (record) => {
        Modal.confirm({
            title: 'NOTICE',
            content: 'Do you want to delete this record?',
            onOk: () => postApi('DELETE', `/leavetype/${record.leave_type_id}`, null),
        });
    };

    const openModal = (type, data) => {
        if (type === 'edit') {
            setdataModal(data);
            form.setFieldsValue({ name: data.name, desc: data.desc });
        }
        setIsModal(true);
    };

    const closeModal = () => {
        setdataModal(null);
        setIsModal(false);
        form.resetFields();
    };

    const onFinish = (values) => {
        if (dataModal) {
            postApi("PUT", `/leavetype/${dataModal.leave_type_id}`, values);
        } else {
            postApi("POST", '/leavetype', values);
        }
    };

    const handleTableChange = (pagination, filters, sorter) => {
        setPage({ pagination, filters, sorter });
        if (pagination.pageSize !== page.pagination.pageSize) setData([]);
    };

    const searchData = (value) => {
        setSearch(value);
        setPage({
            pagination: { current: 1, pageSize: 10 },
            sorter: page.sorter
        });
    };

    return (
        <div>
            <Helmet>
                <title>{titlePage}</title>
            </Helmet>
            {isAlert && (
                <Alert
                    message={textAlert}
                    type="success"
                    banner
                    closable
                    afterClose={() => setIsAlert(false)}
                />
            )}
            <h3>Time Off Types</h3>
            <Row>
                <Col span={8}>
                    <Search
                        placeholder="Search"
                        allowClear
                        enterButton="Search"
                        size="middle"
                        onSearch={searchData}
                    />
                </Col>
                <Col span={16} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button type="primary" onClick={() => openModal('add', null)}>
                        <PlusOutlined />
                        <b style={{ marginLeft: 5 }}>Add</b>
                    </Button>
                </Col>
            </Row>
            <br/>
            <Table
                size="middle"
                columns={columns}
                dataSource={data}
                pagination={page.pagination}
                loading={loading}
                onChange={handleTableChange}
            />
            <Modal title="Time Off Type Form" open={isModal} onOk={form.submit} onCancel={closeModal} okText="Save">
                <Form form={form} layout="vertical" onFinish={onFinish}>
                    <Form.Item
                        name="name"
                        label="Name"
                        rules={[{ required: true, message: 'Name is required!' }]}
                    >
                        <Input placeholder='Input your name' />
                    </Form.Item>
                    <Form.Item
                        name="total_leave_days"
                        label="Total Leave Days"
                        rules={[{ required: true, message: 'Total Leave Days is required!' }]}
                    >
                    <InputNumber
                        style={{ width: "100%" }}
                        placeholder="Input total leave days"
                    />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
}

export default LeaveType;
